'use client';

import { PromoZone } from '@fanduel/rewards-hub-client/promo-zone';
import { RewardsAppProvider } from '@fanduel/rewards-hub-client/provider';
import type { Promotion } from '@fanduel/rewards-hub-client/types/promotion';
import type { ComponentProps, ReactNode } from 'react';
import { DEVICE, PRODUCT } from '@/utils/constants';
import { PlaytechGate } from '@/app/components/playtech-gate/playtech-gate';
import { usePromoCarouselConfig } from './use-promo-carousel-config';

export type PromoZoneDeviceType = ComponentProps<typeof PromoZone>['deviceType'];

const DESKTOP_DEVICE_TYPE = DEVICE.DESKTOP as PromoZoneDeviceType;
const IS_POKER_BUILD = process.env.PRODUCT === PRODUCT.POKER;

type PromoCarouselProps = {
    deviceType?: PromoZoneDeviceType;
    initialPromotions?: Promotion[] | null;
};

const CarouselGate = ({ children }: { children: ReactNode }) =>
    IS_POKER_BUILD ? <PlaytechGate>{children}</PlaytechGate> : <>{children}</>;

/**
 * Client-side wrapper for the PromoZone carousel from rewards-hub-client.
 * CasinoConfig is initialized at app startup (via initializeUnifiedModules),
 * so the library reads UM config from IoC singletons automatically.
 */
export const CarouselZoneClient = ({ deviceType = DESKTOP_DEVICE_TYPE, initialPromotions }: PromoCarouselProps) => {
    const { config, handlers, promoHandlers, isSharedStateLoaded } = usePromoCarouselConfig();

    return (
        <div className="promo-carousel-wrapper">
            <RewardsAppProvider>
                <CarouselGate>
                    <PromoZone
                        deviceType={deviceType}
                        initialPromotions={initialPromotions}
                        config={config}
                        handlers={handlers}
                        promoHandlers={promoHandlers}
                        isSharedStateLoaded={isSharedStateLoaded}
                    />
                </CarouselGate>
            </RewardsAppProvider>
        </div>
    );
};
